<svelte:options />

<script>

    import { createEventDispatcher } from 'svelte';
    /**
     * @typedef {Object} Props
     * @property {any} name
     * @property {boolean} [required]
     * @property {any} value
     * @property {any} associatedID
     * @property {number} [tabindex]
     */
    let {
        name,
        required = false,
        value = $bindable(),
        associatedID,
        tabindex = 0
    } = $props();

    const dispatch = createEventDispatcher();

    function handleChange(e) {
        value = e.target.value;
        dispatch('change', {
            originalEvent: e,
            name,
            value,
            required,
            associatedID,
        });
    }

    export {
    	name,
    	required,
    	value,
    	associatedID,
    	tabindex,
    };
</script>

<div class="time-input">
    <input
        class="input"
        {tabindex}
        onchange={handleChange}
        onkeyup={(e) => {
            dispatch('keyup', e);
        }}
        type="time"
        {name}
        {required}
    />
</div>

<style>
    .time-input {
        display: flex;
        flex-direction: row;
        flex-grow: 10;
        width: 100%;
        max-width: 24rem;
    }

    .input {
        padding: 0.75rem;
        background-color: rgba(0, 0, 0, 0.6);
        color: #eee;
        border-radius: 0.35rem;
        border: solid 1px rgba(0, 0, 0, 0.1);
        width: 100%;
    }

    .input:focus {
        background-color: rgba(0, 0, 0, 0.5);
        outline: 1px solid rgb(74, 198, 255);
        color: #eee;
    }
</style>
